module.exports = __webpack_public_path__ + "src/assets/img/cmd-remote-start-gray.385da47e.svg";